import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=3099d830&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=3099d830&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3099d830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3099d830')) {
      api.createRecord('3099d830', component.options)
    } else {
      api.reload('3099d830', component.options)
    }
    module.hot.accept("./CommonTable.vue?vue&type=template&id=3099d830&scoped=true", function () {
      api.rerender('3099d830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/CommonTable.vue"
export default component.exports